import { uriRoot } from 'configs';
export const ROOT = `${uriRoot}/user-right-management/`;
export const MODULE = 'USER_RIGHTS_MANAGEMENT';
